module.exports = __webpack_public_path__ + "img/vector2.307664b4.png";